import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import moment from 'moment'
import { Modal } from 'react-bootstrap'

import { PeriodPicker } from '../../../common/period_picker'
import * as periodPickerConstants from '../../../common/period_picker/constants'
import * as formatters from '../../../common/formatters'
import * as helpers from '../../../common/helpers'
import { LoadingOverlay } from '../../../common/loading_overlay'

import * as reportCostCenterTrafficActionCreators from '../actionCreators'
import { getYear, getData, getFetching, getDetailsData, getDetailsFetching, getDetailsVehiclesData, getDetailsVehiclesFetching } from '../selectors'

import { prepareTableActionCreators } from '../../../common/table/actionCreators'
import { getActiveFilters } from '../../../common/table/helpers'
import { TableModelColumnFilteringType } from '../../../common/table/model'
import { createTableModelSelector } from '../../../common/table/selectors'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'
import {Link} from "react-router-dom";
import {TableFilterCheckboxField} from "../../../common/table/components";

const tableIdentifier = 'report_cost_center_traffic'

class ReportCostCenterTraffic extends Component {
    state = {
        modalDetails: {
            show: false,
            costCenterId: null,
        },
        modalDetailsVehicles: {
            show: false,
            costCenterId: null,
        },
    }

    refresh = () => {
        this.props.actions.fetchReportCostCenterTraffic(this.props.tableModel.get('filters'))
    }

    resetFilters = () => {
        this.props.table.resetFilters()
    }

    isFilterActive = () => getActiveFilters(this.props.tableModel).size > 0

    // Export
    handleExport = e => {
        e && e.preventDefault()

        this.props.actions.exportReportCostCenterTraffic(this.props.tableModel.get('filters').toJS())
    }

    handleFilterChanged = (key, value) => {
        const filters = this.props.tableModel.get('filters')

        let stringFrom = filters.getIn(['date_from', 'value'])
        let stringTo = filters.getIn(['date_to', 'value'])

        if (key === 'period') {
            stringFrom = value.momentFrom.format('DD.MM.YYYY')
            stringTo = value.momentTo.format('DD.MM.YYYY')
        }

        this.props.table.changeFilters([
            {
                column: 'date_from',
                type: TableModelColumnFilteringType.equal,
                value: stringFrom,
            },
            {
                column: 'date_to',
                type: TableModelColumnFilteringType.equal,
                value: stringTo,
            },
        ])
    }

    // Detail
    handleShowDetails = (e, costCenterId) => {
        e && e.preventDefault()

        this.setState(
            {
                modalDetails: {
                    show: true,
                    costCenterId,
                },
            },
            () => {
                const filters = this.props.tableModel.get('filters').toJS()
                filters.costCenterId = { value: costCenterId }

                this.props.actions.fetchReportCostCenterTrafficDetails(filters)
            }
        )
    }

    handleHideDetails = e => {
        e && e.preventDefault()

        this.setState(
            {
                modalDetails: {
                    show: false,
                    costCenterId: null,
                },
            },
            () => {
                this.props.actions.clearReportCostCenterTrafficDetails()
            }
        )
    }

    handleExportDetails = e => {
        e && e.preventDefault()

        const filters = this.props.tableModel.get('filters').toJS()
        filters.costCenterId = { value: this.state.modalDetails.costCenterId }

        this.props.actions.exportReportCostCenterTrafficDetails(filters)
    }

    // Detail vehicles

    handleShowDetailsVehicles = (e, costCenterId) => {
        e && e.preventDefault()

        this.setState(
            {
                modalDetailsVehicles: {
                    show: true,
                    costCenterId,
                },
            },
            () => {
                const filters = this.props.tableModel.get('filters').toJS()
                filters.costCenterId = { value: costCenterId }

                this.props.actions.fetchReportCostCenterTrafficDetailsVehicles(filters)
            }
        )
    }

    handleHideDetailsVehicles = e => {
        e && e.preventDefault()

        this.setState(
            {
                modalDetailsVehicles: {
                    show: false,
                    costCenterId: null,
                },
            },
            () => {
                this.props.actions.clearReportCostCenterTrafficDetailsVehicles()
            }
        )
    }

    handleExportDetailsVehicles = e => {
        e && e.preventDefault()

        const filters = this.props.tableModel.get('filters').toJS()
        filters.costCenterId = { value: this.state.modalDetailsVehicles.costCenterId }

        this.props.actions.exportReportCostCenterTrafficDetailsVehicles(filters)
    }

    componentDidMount() {
        const dateFrom = moment().startOf('month')
        const dateTo = moment().endOf('month')

        this.props.table.setConfiguration(
            [
                {
                    column: 'date_from',
                    type: TableModelColumnFilteringType.equal,
                    value: dateFrom.format('DD.MM.YYYY'),
                },
                {
                    column: 'date_to',
                    type: TableModelColumnFilteringType.equal,
                    value: dateTo.format('DD.MM.YYYY'),
                },
            ],
            false
        )

        this.props.actions.fetchReportCostCenterTraffic(this.props.tableModel.get('filters'))
    }

    componentWillUnmount() {
        this.props.actions.clearReportCostCenterTraffic()
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.reportCostCenterTraffic.heading' }))

        const data = this.props.data
        const filters = this.props.tableModel.get('filters')
        const workingDays = data && data.settings ? data.settings.working_days : 0

        const stringFrom = filters.getIn(['date_from', 'value'])
        const stringTo = filters.getIn(['date_to', 'value'])

        const momentFrom = stringFrom ? helpers.convertCSDateToMoment(stringFrom) : moment().startOf('month')
        const momentTo = stringTo ? helpers.convertCSDateToMoment(stringTo) : moment().endOf('month')

        let totalVehicleCount = 0
        let totalTransportCount = 0
        let totalKM = 0
        let totalCZK = 0
        let totalEUR = 0

        let totalVehiclesTransportCount = 0
        let totalVehiclesKM = 0
        let totalVehiclesCZK = 0
        let totalVehiclesEUR = 0

        const detailsData = this.props.detailsData
        const detailsVehiclesData = this.props.detailsVehiclesData

        let detailsDataTotalKm = 0
        let detailsDataTotalPrice = 0
        let detailsDataTotalKmTransports = []

        /* eslint-disable jsx-a11y/click-events-have-key-events */
        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
        return (
            <PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
                <div className={'page-inner '+(document.body.classList.contains('mobile-menu-open') ? 'sidebar-visible' : '')}>
                    <div id="main-wrapper">
                        <div className="panel panel-white">
                            <div className="panel-body">
                                <div className="wp-100 pull-left m-b-xs">
                                    <h4 className="pull-left">
                                        <span className="pull-left">
                                            <FormattedMessage id="modules.reportCostCenterTraffic.heading" />
                                        </span>
                                    </h4>

                                    <div className="pull-left" style={{ marginLeft: '100px' }}>
                                        <span className="pull-left text-gray f-bold" style={{ paddingTop: '10px' }}>
                                            <FormattedMessage id="fields.showIncl" />:
                                        </span>
                                        <div className="pull-left m-l-sm">
                                            <TableFilterCheckboxField
                                                identifier="with_empty"
                                                type={TableModelColumnFilteringType.bool}
                                                filters={filters}
                                                onChange={this.props.table.changeFilter}
                                                label={this.props.intl.formatMessage({ id: 'fields.showInclEmpty' })}
                                            />
                                        </div>
                                        <div className="pull-left m-l-sm">
                                            <TableFilterCheckboxField
                                                identifier="with_surcharges"
                                                type={TableModelColumnFilteringType.bool}
                                                filters={filters}
                                                onChange={this.props.table.changeFilter}
                                                label={this.props.intl.formatMessage({ id: 'fields.showInclSurcharges' })}
                                            />
                                        </div>
                                    </div>

                                    <div className="btns-list">
                                        <PeriodPicker
                                            className="m-r-lg"
                                            momentFrom={momentFrom}
                                            momentTo={momentTo}
                                            defaultPicker={periodPickerConstants.PERIOD_PICKER_TYPE_MONTH}
                                            onChange={(momentFrom, momentTo) => this.handleFilterChanged('period', { momentFrom, momentTo })}
                                        />
                                        {this.isFilterActive() > 0 && (
                                            <button className="btn btn-default btn-addon m-r-xs" onClick={this.resetFilters}>
                                                <i className="far fa-times" /> <FormattedMessage id="buttons.resetFilters" />
                                            </button>
                                        )}
                                        <button className="btn btn-default btn-addon m-r-xs" onClick={this.refresh}>
                                            <i className="far fa-sync-alt" /> <FormattedMessage id="buttons.refresh" />
                                        </button>
                                        <PermissionsCheck has={[PERMS.EXPORT]}>
                                            <button className="btn btn-primary btn-addon" onClick={this.handleExport}>
                                                <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                            </button>
                                        </PermissionsCheck>
                                    </div>
                                </div>

                                <div className="table-container">
                                    <table className="table table-striped table-hover table-fixed-header">
                                        <thead>
                                            <tr>
                                                <th className="w-max wm-200" />
                                                <th className="w-120 text-right" />
                                                <th className="w-120 text-right" />
                                                <th className="w-350 th-spanned text-center" colSpan={4}>
                                                    KM
                                                </th>
                                                <th className="w-460 th-spanned text-center" colSpan={5}>
                                                    CZK
                                                </th>
                                                <th className="w-540 th-spanned text-center" colSpan={6}>
                                                    EUR
                                                </th>
                                            </tr>
                                            <tr className="th-bordered">
                                                <th className="w-max wm-200">
                                                    <FormattedMessage id="fields.costCenter" />
                                                </th>
                                                <th className="w-120 text-right">
                                                    <FormattedMessage id="fields.vehicleCount" />
                                                </th>
                                                <th className="w-120 text-right">
                                                    <FormattedMessage id="fields.transportCount" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.total" />
                                                </th>
                                                <th className="w-90 text-right">
                                                    <FormattedMessage id="fields.day" />
                                                </th>
                                                <th className="w-80 text-right">
                                                    <FormattedMessage id="fields.vehicle" />
                                                </th>
                                                <th className="w-80 text-right">
                                                    <FormattedMessage id="fields.transport" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.total" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.day" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.vehicle" />
                                                </th>
                                                <th className="w-80 text-right">
                                                    <FormattedMessage id="fields.transport" />
                                                </th>
                                                <th className="w-80 text-right">
                                                    <FormattedMessage id="fields.km" />
                                                </th>
                                                <th className="w-80 text-right">
                                                    <FormattedMessage id="fields.exchangeRate" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.total" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.day" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.vehicle" />
                                                </th>
                                                <th className="w-80 text-right">
                                                    <FormattedMessage id="fields.transport" />
                                                </th>
                                                <th className="w-80 text-right">
                                                    <FormattedMessage id="fields.km" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data &&
                                                data.cost_centers &&
                                                data.cost_centers.map(costCenter => {
                                                    const vehicleCount = costCenter.vehicle_count
                                                    const transportCount = costCenter.transport_count
                                                    const km = costCenter.km
                                                    const czk = costCenter.total_czk
                                                    const eur = costCenter.total_eur

                                                    totalVehicleCount += vehicleCount
                                                    totalTransportCount += transportCount
                                                    totalKM += km
                                                    totalCZK += czk
                                                    totalEUR += eur

                                                    return (
                                                        <tr key={`costCenter-${costCenter.id}`}>
                                                            <td
                                                                className="w-max wm-200 td-clickable"
                                                                onClick={e => {
                                                                    this.handleShowDetails(e, costCenter.id)
                                                                }}
                                                            >
                                                                {costCenter.name}
                                                            </td>
                                                            <td
                                                                className="w-120 text-right td-clickable"
                                                                onClick={e => {
                                                                    this.handleShowDetailsVehicles(e, costCenter.id)
                                                                }}
                                                            >
                                                                {formatters.integerFormatter(vehicleCount)}
                                                            </td>
                                                            <td
                                                                className="w-120 text-right td-clickable"
                                                                onClick={e => {
                                                                    this.handleShowDetails(e, costCenter.id)
                                                                }}
                                                            >
                                                                {formatters.integerFormatter(transportCount)}
                                                            </td>
                                                            <td className="w-100 text-right">
                                                                <strong>{formatters.integerFormatter(km)}</strong>
                                                            </td>
                                                            <td className="w-90 text-right">
                                                                {workingDays && formatters.integerFormatter(km / workingDays)}
                                                            </td>
                                                            <td className="w-80 text-right">
                                                                {vehicleCount && formatters.integerFormatter(km / vehicleCount)}
                                                            </td>
                                                            <td className="w-80 text-right">
                                                                {transportCount && formatters.integerFormatter(km / transportCount)}
                                                            </td>
                                                            <td className="w-100 text-right">
                                                                <strong>{formatters.integerFormatter(czk)}</strong>
                                                            </td>
                                                            <td className="w-100 text-right">
                                                                {workingDays && formatters.integerFormatter(czk / workingDays)}
                                                            </td>
                                                            <td className="w-100 text-right">
                                                                {vehicleCount && formatters.integerFormatter(czk / vehicleCount)}
                                                            </td>
                                                            <td className="w-80 text-right">
                                                                {transportCount && formatters.integerFormatter(czk / transportCount)}
                                                            </td>
                                                            <td className="w-80 text-right">{km && formatters.floatFormatter(czk / km, 2)}</td>
                                                            <td className="w-80 text-right">{eur && formatters.floatFormatter(czk / eur, 3)}</td>
                                                            <td className="w-100 text-right">
                                                                <strong>{formatters.integerFormatter(eur)}</strong>
                                                            </td>
                                                            <td className="w-100 text-right">
                                                                {workingDays && formatters.integerFormatter(eur / workingDays)}
                                                            </td>
                                                            <td className="w-100 text-right">
                                                                {vehicleCount && formatters.integerFormatter(eur / vehicleCount)}
                                                            </td>
                                                            <td className="w-80 text-right">
                                                                {transportCount && formatters.integerFormatter(eur / transportCount)}
                                                            </td>
                                                            <td className="w-80 text-right">{km && formatters.floatFormatter(eur / km, 2)}</td>
                                                        </tr>
                                                    )
                                                })}

                                            <tr className="b-top row-sum">
                                                <td className="w-max wm-200">
                                                    <strong>
                                                        <FormattedMessage id="fields.total" />:
                                                    </strong>
                                                </td>
                                                <td className="w-120 text-right">
                                                    <strong>{formatters.integerFormatter(totalVehicleCount)}</strong>
                                                </td>
                                                <td className="w-120 text-right">
                                                    <strong>{formatters.integerFormatter(totalTransportCount)}</strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{formatters.integerFormatter(totalKM)}</strong>
                                                </td>
                                                <td className="w-90 text-right">
                                                    <strong>{workingDays && formatters.integerFormatter(totalKM / workingDays)}</strong>
                                                </td>
                                                <td className="w-80 text-right">
                                                    <strong>{totalVehicleCount && formatters.integerFormatter(totalKM / totalVehicleCount)}</strong>
                                                </td>
                                                <td className="w-80 text-right">
                                                    <strong>
                                                        {totalTransportCount && formatters.integerFormatter(totalKM / totalTransportCount)}
                                                    </strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{formatters.integerFormatter(totalCZK)}</strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{workingDays && formatters.integerFormatter(totalCZK / workingDays)}</strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{totalVehicleCount && formatters.integerFormatter(totalCZK / totalVehicleCount)}</strong>
                                                </td>
                                                <td className="w-80 text-right">
                                                    <strong>
                                                        {totalTransportCount && formatters.integerFormatter(totalCZK / totalTransportCount)}
                                                    </strong>
                                                </td>
                                                <td className="w-80 text-right">
                                                    <strong>{totalKM && formatters.floatFormatter(totalCZK / totalKM, 2)}</strong>
                                                </td>
                                                <td className="w-80 text-right">
                                                    <strong>{totalEUR && formatters.floatFormatter(totalCZK / totalEUR, 3)}</strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{formatters.integerFormatter(totalEUR)}</strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{workingDays && formatters.integerFormatter(totalEUR / workingDays)}</strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{totalVehicleCount && formatters.integerFormatter(totalEUR / totalVehicleCount)}</strong>
                                                </td>
                                                <td className="w-80 text-right">
                                                    <strong>
                                                        {totalTransportCount && formatters.integerFormatter(totalEUR / totalTransportCount)}
                                                    </strong>
                                                </td>
                                                <td className="w-80 text-right">
                                                    <strong>{totalKM && formatters.floatFormatter(totalEUR / totalKM, 2)}</strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal show={Boolean(this.state.modalDetails.show)} onHide={this.handleHideDetails} className="modal-size-xl">
                        <Modal.Header closeButton>
                            <Modal.Title>{detailsData ? detailsData.title : null}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <LoadingOverlay active={this.props.detailsFetching}>
                                <div className="btns-list">
                                    {detailsData && detailsData.transports.length > 0 && (
                                        <PermissionsCheck has={[PERMS.EXPORT]}>
                                            <button className="btn btn-primary btn-addon m-r-xs" onClick={this.handleExportDetails}>
                                                <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                            </button>
                                        </PermissionsCheck>
                                    )}
                                </div>

                                <div className="table-container">
                                    <table className="table table-striped table-hover table-fixed-header">
                                        <thead>
                                            <tr>
                                                <th className="w-80 text-center">
                                                    <FormattedMessage id="fields.date" />
                                                </th>
                                                <th className="w-80 text-center">
                                                    <FormattedMessage id="fields.number" />
                                                </th>
                                                <th className="w-max wm-140">
                                                    <FormattedMessage id="fields.orderNumber" />
                                                </th>
                                                <th className="w-160">
                                                    <FormattedMessage id="fields.loadingCity" />
                                                </th>
                                                <th className="w-60 text-center">
                                                    <FormattedMessage id="fields.loadingCountry" />
                                                </th>
                                                <th className="w-160">
                                                    <FormattedMessage id="fields.unloadingCity" />
                                                </th>
                                                <th className="w-60 text-center">
                                                    <FormattedMessage id="fields.unloadingCountry" />
                                                </th>
                                                <th className="w-100 text-center">
                                                    <FormattedMessage id="fields.registration" />
                                                </th>
                                                <th className="w-140">
                                                    <FormattedMessage id="fields.dispatcher" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.km" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.price" />
                                                </th>
                                                <th className="w-120 text-right">
                                                    <FormattedMessage id="fields.priceCZK" />
                                                </th>
                                                <th className="w-90 text-right">
                                                    <FormattedMessage id="fields.profitKM" />
                                                </th>
                                                <th className="w-90 text-right">
                                                    <FormattedMessage id="fields.profitKMCZK" />
                                                </th>
                                                <th className="w-60 text-right">
                                                    <FormattedMessage id="fields.exchangeRate" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detailsData &&
                                                detailsData.transports.map(transport => {
                                                    if (detailsDataTotalKmTransports.indexOf(transport.number) === -1) {
                                                        detailsDataTotalKm += transport.km
                                                    }

                                                    detailsDataTotalPrice += transport.price_czk

                                                    detailsDataTotalKmTransports.push(transport.number)

                                                    const datetime = moment(transport.datetime)

                                                    return (
                                                        <tr key={`transport-${transport.number}`}>
                                                            <td className="w-80 text-center">{formatters.dateFormatter(datetime)}</td>
                                                            <td className="w-80 text-center">
                                                                <Link to={`/transports/${transport.number}`}>
                                                                    {transport.number}
                                                                </Link>
                                                            </td>
                                                            <td className="w-max wm-140">{transport.order_number}</td>
                                                            <td className="w-160">{transport.loading_city}</td>
                                                            <td className="w-60 text-center">{transport.loading_country}</td>
                                                            <td className="w-160">{transport.unloading_city}</td>
                                                            <td className="w-60 text-center">{transport.unloading_country}</td>
                                                            <td className="w-100 text-center">{transport.registration}</td>
                                                            <td className="w-140">{transport.dispatcher}</td>
                                                            <td className="w-100 text-right">{formatters.distanceFormatter(transport.km)}</td>
                                                            <td className=" text-right">
                                                                {formatters.priceFormatter(transport.price, '0,0', transport.currency_code)}
                                                            </td>
                                                            <td className="w-120 text-right">{formatters.priceFormatter(transport.price_czk)}</td>
                                                            <td className="w-90 text-right">{formatters.floatFormatter(transport.profit_km, 2)}</td>
                                                            <td className="w-90 text-right">
                                                                {formatters.floatFormatter(transport.profit_km_czk, 2)}
                                                            </td>
                                                            <td className="w-60 text-right">
                                                                {formatters.floatFormatter(transport.currency_rate, 2)}
                                                            </td>
                                                        </tr>
                                                    )
                                                })}

                                            <tr className="b-top row-sum">
                                                <td className="w-max" colSpan={9}>
                                                    <strong>
                                                        <FormattedMessage id="fields.total" />:
                                                    </strong>
                                                </td>
                                                <td className="w-100 text-right">
                                                    <strong>{formatters.distanceFormatter(detailsDataTotalKm)}</strong>
                                                </td>
                                                <td className="w-100 text-right" />
                                                <td className="w-120 text-right">
                                                    <strong>{formatters.priceFormatter(detailsDataTotalPrice)}</strong>
                                                </td>
                                                <td className="w-90 text-right" />
                                                <td className="w-90 text-right">
                                                    <strong>
                                                        {formatters.floatFormatter(
                                                            detailsDataTotalKm ? detailsDataTotalPrice / detailsDataTotalKm : 0
                                                        )}
                                                    </strong>
                                                </td>
                                                <td className="w-60 text-right" />
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </LoadingOverlay>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-default" onClick={this.handleHideDetails}>
                                <FormattedMessage id="confirmDialog.duplicityFound.cancel" />
                            </button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={Boolean(this.state.modalDetailsVehicles.show)} onHide={this.handleHideDetailsVehicles} className="modal-size-xl">
                        <Modal.Header closeButton>
                            <Modal.Title>{detailsVehiclesData ? detailsVehiclesData.title : null}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <LoadingOverlay active={this.props.detailsVehiclesFetching}>
                                <div className="btns-list">
                                    {detailsVehiclesData && detailsVehiclesData.vehicles.length > 0 && (
                                        <PermissionsCheck has={[PERMS.EXPORT]}>
                                            <button className="btn btn-primary btn-addon m-r-xs" onClick={this.handleExportDetailsVehicles}>
                                                <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                            </button>
                                        </PermissionsCheck>
                                    )}
                                </div>

                                <div className="table-container">
                                    <table className="table table-striped table-hover table-fixed-header">
                                        <thead>
                                        <tr>
                                            <th className="w-max wm-200" />
                                            <th className="w-120 text-right" />
                                            <th className="w-270 th-spanned text-center" colSpan={3}>
                                                KM
                                            </th>
                                            <th className="w-360 th-spanned text-center" colSpan={4}>
                                                CZK
                                            </th>
                                            <th className="w-440 th-spanned text-center" colSpan={5}>
                                                EUR
                                            </th>
                                        </tr>
                                        <tr className="th-bordered">
                                            <th className="w-max wm-200">
                                                <FormattedMessage id="fields.vehicle" />
                                            </th>
                                            <th className="w-120 text-right">
                                                <FormattedMessage id="fields.transportCount" />
                                            </th>
                                            <th className="w-100 text-right">
                                                <FormattedMessage id="fields.total" />
                                            </th>
                                            <th className="w-90 text-right">
                                                <FormattedMessage id="fields.day" />
                                            </th>
                                            <th className="w-80 text-right">
                                                <FormattedMessage id="fields.transport" />
                                            </th>
                                            <th className="w-100 text-right">
                                                <FormattedMessage id="fields.total" />
                                            </th>
                                            <th className="w-100 text-right">
                                                <FormattedMessage id="fields.day" />
                                            </th>
                                            <th className="w-80 text-right">
                                                <FormattedMessage id="fields.transport" />
                                            </th>
                                            <th className="w-80 text-right">
                                                <FormattedMessage id="fields.km" />
                                            </th>
                                            <th className="w-80 text-right">
                                                <FormattedMessage id="fields.exchangeRate" />
                                            </th>
                                            <th className="w-100 text-right">
                                                <FormattedMessage id="fields.total" />
                                            </th>
                                            <th className="w-100 text-right">
                                                <FormattedMessage id="fields.day" />
                                            </th>
                                            <th className="w-80 text-right">
                                                <FormattedMessage id="fields.transport" />
                                            </th>
                                            <th className="w-80 text-right">
                                                <FormattedMessage id="fields.km" />
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {detailsVehiclesData &&
                                            detailsVehiclesData.vehicles &&
                                            detailsVehiclesData.vehicles.map(vehicle => {
                                                const transportCount = vehicle.transport_count
                                                const km = vehicle.km
                                                const czk = vehicle.total_czk
                                                const eur = vehicle.total_eur

                                                totalVehiclesTransportCount += transportCount
                                                totalVehiclesKM += km
                                                totalVehiclesCZK += czk
                                                totalVehiclesEUR += eur

                                                return (
                                                    <tr key={`vehicle-${vehicle.id}`}>
                                                        <td className="w-max wm-200">
                                                            {vehicle.name}
                                                        </td>
                                                        <td className="w-120 text-right">
                                                            {formatters.integerFormatter(transportCount)}
                                                        </td>
                                                        <td className="w-100 text-right">
                                                            <strong>{formatters.integerFormatter(km)}</strong>
                                                        </td>
                                                        <td className="w-90 text-right">
                                                            {workingDays && formatters.integerFormatter(km / workingDays)}
                                                        </td>
                                                        <td className="w-80 text-right">
                                                            {transportCount && formatters.integerFormatter(km / transportCount)}
                                                        </td>
                                                        <td className="w-100 text-right">
                                                            <strong>{formatters.integerFormatter(czk)}</strong>
                                                        </td>
                                                        <td className="w-100 text-right">
                                                            {workingDays && formatters.integerFormatter(czk / workingDays)}
                                                        </td>
                                                        <td className="w-80 text-right">
                                                            {transportCount && formatters.integerFormatter(czk / transportCount)}
                                                        </td>
                                                        <td className="w-80 text-right">{km && formatters.floatFormatter(czk / km, 2)}</td>
                                                        <td className="w-80 text-right">{eur && formatters.floatFormatter(czk / eur, 3)}</td>
                                                        <td className="w-100 text-right">
                                                            <strong>{formatters.integerFormatter(eur)}</strong>
                                                        </td>
                                                        <td className="w-100 text-right">
                                                            {workingDays && formatters.integerFormatter(eur / workingDays)}
                                                        </td>
                                                        <td className="w-80 text-right">
                                                            {transportCount && formatters.integerFormatter(eur / transportCount)}
                                                        </td>
                                                        <td className="w-80 text-right">{km && formatters.floatFormatter(eur / km, 2)}</td>
                                                    </tr>
                                                )
                                            })}

                                        <tr className="b-top row-sum">
                                            <td className="w-max wm-200">
                                                <strong>
                                                    <FormattedMessage id="fields.total" />:
                                                </strong>
                                            </td>
                                            <td className="w-120 text-right">
                                                <strong>{formatters.integerFormatter(totalVehiclesTransportCount)}</strong>
                                            </td>
                                            <td className="w-100 text-right">
                                                <strong>{formatters.integerFormatter(totalVehiclesKM)}</strong>
                                            </td>
                                            <td className="w-90 text-right">
                                                <strong>{workingDays && formatters.integerFormatter(totalVehiclesKM / workingDays)}</strong>
                                            </td>
                                            <td className="w-80 text-right">
                                                <strong>
                                                    {totalVehiclesTransportCount && formatters.integerFormatter(totalVehiclesKM / totalVehiclesTransportCount)}
                                                </strong>
                                            </td>
                                            <td className="w-100 text-right">
                                                <strong>{formatters.integerFormatter(totalVehiclesCZK)}</strong>
                                            </td>
                                            <td className="w-100 text-right">
                                                <strong>{workingDays && formatters.integerFormatter(totalVehiclesCZK / workingDays)}</strong>
                                            </td>
                                            <td className="w-80 text-right">
                                                <strong>
                                                    {totalVehiclesTransportCount && formatters.integerFormatter(totalVehiclesCZK / totalVehiclesTransportCount)}
                                                </strong>
                                            </td>
                                            <td className="w-80 text-right">
                                                <strong>{totalVehiclesKM && formatters.floatFormatter(totalVehiclesCZK / totalVehiclesKM, 2)}</strong>
                                            </td>
                                            <td className="w-80 text-right">
                                                <strong>{totalVehiclesEUR && formatters.floatFormatter(totalVehiclesCZK / totalVehiclesEUR, 3)}</strong>
                                            </td>
                                            <td className="w-100 text-right">
                                                <strong>{formatters.integerFormatter(totalVehiclesEUR)}</strong>
                                            </td>
                                            <td className="w-100 text-right">
                                                <strong>{workingDays && formatters.integerFormatter(totalVehiclesEUR / workingDays)}</strong>
                                            </td>
                                            <td className="w-80 text-right">
                                                <strong>
                                                    {totalVehiclesTransportCount && formatters.integerFormatter(totalVehiclesEUR / totalVehiclesTransportCount)}
                                                </strong>
                                            </td>
                                            <td className="w-80 text-right">
                                                <strong>{totalVehiclesKM && formatters.floatFormatter(totalVehiclesEUR / totalVehiclesKM, 2)}</strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </LoadingOverlay>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-default" onClick={this.handleHideDetailsVehicles}>
                                <FormattedMessage id="confirmDialog.duplicityFound.cancel" />
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </PermissionsCheck>
        )
        /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
        /* eslint-enable jsx-a11y/click-events-have-key-events */
    }
}

function mapStateToProps(state) {
    return {
        tableModel: createTableModelSelector(tableIdentifier)(state),
        year: getYear(state),
        data: getData(state),
        fetching: getFetching(state),
        detailsData: getDetailsData(state),
        detailsFetching: getDetailsFetching(state),
        detailsVehiclesData: getDetailsVehiclesData(state),
        detailsVehiclesFetching: getDetailsVehiclesFetching(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...reportCostCenterTrafficActionCreators,
                },
                dispatch
            ),
        },
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        table: bindActionCreators(prepareTableActionCreators(tableIdentifier, stateProps.tableModel), dispatchProps.dispatch),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(ReportCostCenterTraffic)
)
